// Utilidades para convertir distintas formas de imagen a dataURI válida

// Convierte un arreglo de bytes (Array o Uint8Array) a base64 en navegador
function bytesToBase64(bytes) {
  try {
    let binary = '';
    const chunkSize = 0x8000; // procesar en chunks para evitar call stack overflow
    for (let i = 0; i < bytes.length; i += chunkSize) {
      const chunk = bytes.subarray ? bytes.subarray(i, i + chunkSize) : bytes.slice(i, i + chunkSize);
      binary += String.fromCharCode.apply(null, chunk);
    }
    return btoa(binary);
  } catch (e) {
    return null;
  }
}

// Acepta diferentes formas: string (dataURI o base64), {type:'Buffer', data:[...]}, Array<number>, Uint8Array
export function toBase64FromPossible(value) {
  if (!value) return null;
  if (typeof value === 'string') {
    // Si ya es dataURI, devolver tal cual. Si es base64 crudo, retornarlo.
    if (value.startsWith('data:')) return value;
    return value;
  }
  // Buffer-like serializado por JSON: { type: 'Buffer', data: [...] }
  if (typeof value === 'object') {
    const dataArr = Array.isArray(value) ? value
      : Array.isArray(value.data) ? value.data
      : null;
    if (dataArr) {
      const bytes = (value instanceof Uint8Array) ? value : new Uint8Array(dataArr);
      return bytesToBase64(bytes);
    }
  }
  return null;
}

export function buildDataUriFromPossible(value, mime) {
  if (!value) return null;
  if (typeof value === 'string' && value.startsWith('data:')) return value;
  const base64 = toBase64FromPossible(value);
  if (!base64) return null;
  const mediaType = (typeof mime === 'string' && mime) ? mime : 'image/jpeg';
  return `data:${mediaType};base64,${base64}`;
}

export default {
  toBase64FromPossible,
  buildDataUriFromPossible,
};
